module.exports = __webpack_public_path__ + "img/ant.a8708b35.png";